import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductList from "../components/ProductList";

const StoreDetailsPage = () => {
  const { slug } = useParams();
  const [store, setStore] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStoreData = async () => {
      try {
        // Fetch store details
        const storeResponse = await fetch(
          `https://mycobro.com/api/admin/stores/${slug}`
        );
        if (!storeResponse.ok) throw new Error("Failed to fetch store details");
        const storeData = await storeResponse.json();
        setStore(storeData);

        // Fetch products using the store ID from the store response
        const productsResponse = await fetch(
          `https://mycobro.com/api/products/store/${storeData._id}`
        );
        if (!productsResponse.ok) throw new Error("Failed to fetch products");
        const productsData = await productsResponse.json();
        setProducts(productsData);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStoreData();
  }, [slug]); // Only depend on slug

  if (loading) return <p className="text-center text-lg">Loading store details...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  return (
    <div className="max-w-4xl mx-auto my-10 p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-4xl font-bold mb-4 text-gray-800">{store.name}</h1>
      <p className="text-gray-600 mb-2"><strong>Description:</strong> {store.description || "No description available"}</p>
      <p className="text-gray-600 mb-2"><strong>Location:</strong> {store.location}</p>
      <p className="text-gray-600 mb-2"><strong>Owner ID:</strong> {"****"}</p>
      <p className="text-gray-600"><strong>Created At:</strong> {"****"}</p>

      <button
        className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
        onClick={() => window.history.back()}
      >
        Go Back
      </button>

      <div className="mt-8">
        <h2 className="text-2xl font-bold mb-4">Products</h2>
        {products.length > 0 ? (
          <ProductList products={products} />
        ) : (
          <p className="text-gray-500">No products available in this store</p>
        )}
      </div>
    </div>
  );
};

export default StoreDetailsPage;